export default __webpack_public_path__ + "static/logo-7-29630c6850ec90632557986ee9a24bdc.jpeg";